import { useEffect, useState, memo, useCallback, Fragment } from "react"
import './Tabs.css'

const Tabs = ({ tabs = [], value, onChange, children }) => {
  const [tab, setTab] = useState()
  useEffect(() => {
    if (value || !tab) {
      setTab(value || tabs[0]?.key)
    }
  }, [value, tabs])

  const handleChange = useCallback((key) => {
    setTab(key)
    onChange && onChange(key)
  }, [])
  return <div className="com-tabs">
    <div className="com-tabs-header">
      {
        tabs.map(({ title, key }) => <div
          key={key}
          className={key === tab ? 'com-tab active' : 'com-tab'}
          onClick={() => handleChange(key)}
        >
          { title }
        </div>)
      }
    </div>
    <div className="tab-content">
      {
        children.map(item => <div
          key={item.key}
          style={{ display: item.key == tab ? 'block' : 'none' }}
        >
          { item }
        </div>)
      }
    </div>
  </div>
}

export default memo(Tabs)
